const P = (n) => Math.round(n * 100);

const esc = (v) =>
  String(v ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ],
  );

const peso = (c) =>
  (c < 0 ? "(" : "") +
  "₱" +
  (Math.abs(c) / 100).toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) +
  (c < 0 ? ")" : "");

const initials = (n) =>
  n
    .split(/[\s,.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((x) => x[0])
    .join("");

const pad2 = (n) => String(n).padStart(2, "0");

const pesoShort = (c) => {
  const v = Math.abs(c) / 100,
    g = c < 0 ? "−" : "";
  return v >= 1e6
    ? `${g}₱${(v / 1e6).toFixed(2)}M`
    : v >= 1e3
      ? `${g}₱${(v / 1e3).toFixed(0)}K`
      : peso(c);
};

export { P, esc, peso, initials, pad2, pesoShort };
